interface SectionHeaderProps {
  header: string
}

export const SectionHeader = ({ header }: SectionHeaderProps) => {
  return <h2 className="section-header">{header}</h2>
}
